import { useState } from 'react';

interface VideoConferenceFieldProps {
  hangoutLink?: string | null;
  customConferenceUrl?: string | null;
  createGoogleMeet: boolean;
  onCreateGoogleMeetChange: (value: boolean) => void;
  onCustomConferenceUrlChange: (value: string) => void;
  viewOnly?: boolean;
}

export function VideoConferenceField({
  hangoutLink,
  customConferenceUrl,
  createGoogleMeet,
  onCreateGoogleMeetChange,
  onCustomConferenceUrlChange,
  viewOnly,
}: VideoConferenceFieldProps) {
  const [mode, setMode] = useState<'none' | 'meet' | 'custom'>(
    hangoutLink ? 'meet' : customConferenceUrl ? 'custom' : createGoogleMeet ? 'meet' : 'none'
  );

  const hasExistingLink = !!(hangoutLink || customConferenceUrl);

  if (hasExistingLink && mode !== 'none') {
    const link = hangoutLink || customConferenceUrl || '';
    const label = hangoutLink ? 'Google Meet' : 'Video call';
    return (
      <div className="video-conference-field">
        <div className="video-link-display">
          <span className="video-link-label">{label}</span>
          <a href={link} target="_blank" rel="noopener noreferrer" className="video-link-url">
            {link}
          </a>
          {!viewOnly && (
            <button
              type="button"
              className="video-link-remove"
              onClick={() => {
                setMode('none');
                onCreateGoogleMeetChange(false);
                onCustomConferenceUrlChange('');
              }}
              title="Remove video link"
            >
              &times;
            </button>
          )}
        </div>
      </div>
    );
  }

  if (viewOnly) return null;

  if (mode === 'none') {
    return (
      <div className="video-conference-field">
        <div className="video-conference-picker">
          <button
            type="button"
            className="video-option-btn video-option-meet"
            onClick={() => {
              setMode('meet');
              onCreateGoogleMeetChange(true);
              onCustomConferenceUrlChange('');
            }}
          >
            Google Meet
          </button>
          <button
            type="button"
            className="video-option-btn video-option-custom"
            onClick={() => {
              setMode('custom');
              onCreateGoogleMeetChange(false);
            }}
          >
            Custom link
          </button>
        </div>
      </div>
    );
  }

  if (mode === 'meet') {
    return (
      <div className="video-conference-field">
        <div className="video-meet-pending">
          <span>Google Meet link will be generated on save</span>
          <button
            type="button"
            className="video-link-remove"
            onClick={() => {
              setMode('none');
              onCreateGoogleMeetChange(false);
            }}
          >
            &times;
          </button>
        </div>
      </div>
    );
  }

  // mode === 'custom'
  return (
    <div className="video-conference-field">
      <div className="video-custom-input-row">
        <input
          type="url"
          className="video-custom-input"
          placeholder="Paste Zoom, Teams, or other video link..."
          value={customConferenceUrl || ''}
          onChange={e => onCustomConferenceUrlChange(e.target.value)}
          autoFocus
        />
        <button
          type="button"
          className="video-link-remove"
          onClick={() => {
            setMode('none');
            onCustomConferenceUrlChange('');
          }}
        >
          &times;
        </button>
      </div>
    </div>
  );
}
